module.exports = __webpack_public_path__ + "static/play-1e4d76435422fa7fd1a4f98ac653b33d.png";